import { useSpeciesCard } from "@/domain/Breeds/useCases/useSpeciesCard";

import Button from "@/components/shared/Button";

import type { SpeciesCardProps } from "./speciesCard.types";

import s from "./speciesCard.module.scss";

const SpecieCard = ({ speciesType }: SpeciesCardProps) => {
  const { handleOnClick } = useSpeciesCard({ species: speciesType.path });

  return (
    <div className={s.wrapper}>
      <img
        src={speciesType.image}
        alt={`Imagem de ${speciesType.name}`}
        width={163}
        height={163}
        fetchPriority="high"
        className={s.image}
      />
      <div className={s.content}>
        <h4 className={s.title}>{`Guia de Raças: ${speciesType.name}`}</h4>
        <p className={s.description}>{speciesType.description}</p>
        <Button variant="turquoise" size="sm" onClick={handleOnClick}>
          Ir para o guia
        </Button>
      </div>
    </div>
  );
};
export default SpecieCard;
